import React from "react";
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";
const ApexRadial = ({ dataColors, label, value }) => {
  const apexRadialChartColors = getChartColorsArray(dataColors);
  const series = [value];
  const options = {
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: "10px", // Reduced font size
            color: void 0,
            offsetY: 50,
          },
          value: {
            offsetY: 15,
            fontSize: "12px", // Reduced font size
            color: void 0,
            formatter: function (e) {
              return e + "%";
            },
          },
        },
      },
    },
    colors: apexRadialChartColors,
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        shadeIntensity: 0.15,
        inverseColors: !1,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 4,
    },
    labels: [label],
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="120" // Reduced height
      width="120"  // Reduced width
      className="apex-charts"
    />
  );
};



export default ApexRadial;
